import { render, staticRenderFns } from "./FolderLsport.vue?vue&type=template&id=483a53c6&scoped=true"
import script from "./FolderLsport.vue?vue&type=script&lang=js"
export * from "./FolderLsport.vue?vue&type=script&lang=js"
import style0 from "./FolderLsport.vue?vue&type=style&index=0&id=483a53c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a53c6",
  null
  
)

export default component.exports